<template>
    <a class="list-page__item" :class="item.listItemType" :href="item.url">
        <figure v-if="item.imageUrl && item.listItemType == 0" class="list-page__item-image">
            <img :srcset="`${item.imageUrl} 480w,${item.imageUrl}1440w`"
                 sizes="(max-width: 480px) 480px, (max-width: 1440px) 1440px, 1920px"
                 :src="item.imageUrl" width="600" height="369" alt="">
        </figure>
        <div v-if="!item.imageUrl" class="list-page__image-substitute">

        </div>
        <div class="list-page__item-content">      
            <Heading :tag="headingType" class="h3" :data="item.heading"></Heading>
            <p v-html="item.cardIntro"></p>
        </div>
    </a>
</template>

<script setup>
    import Heading from '@/vue/elements/heading.vue';
    const props = defineProps({
        item: {},
        headingType: {
            type: String,
            default: 'h2'
        }
    })
</script>